/**
 * Component to render SCA Special recognition award page
 */
const SpecialRecognitionAwardPage = (): React.ReactElement => {
  return (
    <div
      className="mb-10 font-public-sans"
      data-testid="special-recognition-award-page-component"
    >
      <p>
        <strong>Objectives of the Award</strong>
      </p>

      <p>
        The objective of the SCA Special Recognition Award is to recognise
        individuals and/or organisations that have demonstrated outstanding and
        exemplary corporate governance in the conduct of the affairs of their
        boards and organisations.
      </p>

      <p>
        This award is meant to recognise specific recent actions and practices
        of boards and companies that deserved to be highlighted. It does not
        seek to feature the same grounds already covered in the other SCA awards
        such as the Best Managed Board, Best CEO, Best CFO, Best Investor
        Relations and Best Annual Report.
      </p>

      <p>
        <strong>Categories of the Award</strong>
      </p>

      <p className="mb-0">There are no award categories.</p>

      <p>
        One or more awards may be given out depending upon the merits of the
        nomination. No award will be given if there are no nominations deemed
        appropriate by the judges.
      </p>

      <p>
        <strong>Selection and Judging Process</strong>
      </p>

      <p>
        There will be a call for nominations from the corporate community at
        large.
      </p>

      <p>
        Nominations are to be sent to the Singapore Corporate Awards
        Secretariat. Nominations are in free form but should provide the name
        and contact information of the nominator, a seconder, and the name and
        any supporting information of the nominee. Self-nominations are allowed.
      </p>

      <p>
        In addition to the nominations submitted, other candidates may be
        identified by the Singapore Corporate Awards Secretariat through
        industry knowledge and media.
      </p>

      <p>
        The SCA Steering Committee will then review all nominations and decide
        on who or which organisations are deserving of the award.
      </p>

      <p>
        <strong>Criteria</strong>
      </p>

      <p>
        Individuals and/or organisations that have demonstrated outstanding and
        exemplary corporate governance in the conduct of the affairs of their
        boards and organisations especially in the past year or more in an area
        not already covered by an existing SCA award.
      </p>

      <div className="mt-12 text-xs">
        <p>
          For more information, please contact the Singapore Institute of
          Directors:
        </p>

        <ul className="mb-6 list-none">
          <li>Mr Edwin Lee;</li>
          <li>Email: edwin@sid.org.sg;</li>
          <li>DID: 6011 0100 / 6422 1188;</li>
        </ul>

        <ul className="list-none">
          <li>Singapore Institute of Directors;</li>
          <li>168, #11-03 Robinson Rd, Capital Tower, 068912;</li>
        </ul>
      </div>
    </div>
  );
};

export default SpecialRecognitionAwardPage;
